import { render, staticRenderFns } from "./NameserversInstructionsStep.vue?vue&type=template&id=4dcd6d8a&scoped=true&"
import script from "./NameserversInstructionsStep.vue?vue&type=script&lang=js&"
export * from "./NameserversInstructionsStep.vue?vue&type=script&lang=js&"
import style0 from "./NameserversInstructionsStep.vue?vue&type=style&index=0&id=4dcd6d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd6d8a",
  null
  
)

export default component.exports